import React from "react";
import { CreditCardBackIcon } from "@bookingcom/bui-assets-react/streamline";
import { Banner, Link, Text } from "@bookingcom/bui-react";
import { useInstallmentsController } from "./useInstallments.controller";

export function Installments() {
  const { text, href, cta, pointOfSale } = useInstallmentsController();

  if (pointOfSale !== "br") return null;

  return (
    <Banner dismissible={false} startIcon={CreditCardBackIcon}>
      <Text variant="body_2">{text}</Text>
      <Link href={href} variant="primary" attributes={{ target: "_blank", rel: "noreferrer" }}>
        {cta}
      </Link>
    </Banner>
  );
}
